/**
 * awe-footer-local-amount.js
 *
 * Replaces each [data-awe-local-amount="<USD amount>"] element with that amount
 * converted to the visitor's Shopify Markets currency, e.g. 200 -> "£154".
 *
 * Why this is JS: Liquid's money filters format a raw number in the visitor's
 * currency but do not convert it. Shopify exposes the active exchange rate to
 * the storefront as Shopify.currency.rate (USD -> active currency), which is
 * what the cart and prices use.
 *
 * Leaves the server-rendered "$<amount>" in place when the currency is USD,
 * when no rate is available, or if formatting fails.
 */
(() => {
  const currency = window.Shopify && window.Shopify.currency;
  if (!currency || !currency.active || currency.active === 'USD') return;

  const rate = parseFloat(currency.rate);
  if (!rate || !isFinite(rate) || rate <= 0) return;

  const locale = document.documentElement.lang || undefined;

  document.querySelectorAll('[data-awe-local-amount]').forEach((el) => {
    const usd = parseFloat(el.getAttribute('data-awe-local-amount'));
    if (!usd || !isFinite(usd)) return;

    try {
      const formatted = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency.active,
        maximumFractionDigits: 0,
      }).format(Math.round(usd * rate));
      el.textContent = formatted;
    } catch (_) {
      /* keep the USD fallback */
    }
  });
})();
